import { useEffect } from 'react';

import { Navigate } from '@sorare/routing';

import {
  ANY_SPORT_ONBOARDING_SERIES_SELECT_COMPETITION,
  FOOTBALL_ONBOARDING_SELECT_COMPETITION,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { useFootballEvents } from '@sorare/marketplace/src/shared/events/lib';

const ProOnboardingPage = () => {
  const track = useFootballEvents();
  const {
    flags: { enableSeriesOnboardingPacks = false },
  } = useFeatureFlags();
  const { generateSportContextPath } = useSportContext();

  useEffect(() => {
    track('Enter General Tutorial');
  }, [track]);

  if (enableSeriesOnboardingPacks) {
    return (
      <Navigate
        to={generateSportContextPath(
          ANY_SPORT_ONBOARDING_SERIES_SELECT_COMPETITION
        )}
        replace
      />
    );
  }
  return <Navigate to={FOOTBALL_ONBOARDING_SELECT_COMPETITION} replace />;
};

export default ProOnboardingPage;
